import { api } from "@/lib/api";

/** A promo code the server accepted for the chosen plan. */
export interface AppliedPromo {
  code: string;
  discountCents: number;
  totalCents: number;
}

/** Why the server would not apply a code; each has text in checkout.promo.errors. */
export type PromoRejection = "invalid" | "not_started" | "expired" | "used_up" | "min_order";

type QuoteResponse =
  | ({ valid: true; listCents: number } & AppliedPromo)
  | { valid: false; reason: PromoRejection; minOrderCents: number | null };

/**
 * Asks the server what `code` takes off the plan. The server works the
 * discount out again when the order is placed, so this is only for display.
 */
export async function quotePromo(
  code: string,
  tier: string,
  amount: string | undefined
): Promise<{ ok: true; promo: AppliedPromo } | { ok: false; reason: PromoRejection; minOrderCents: number | null }> {
  const data = await api.post<QuoteResponse>("/payments/promo", { code, tier, amount });
  if ("reason" in data) return { ok: false, reason: data.reason, minOrderCents: data.minOrderCents };
  return { ok: true, promo: { code: data.code, discountCents: data.discountCents, totalCents: data.totalCents } };
}
